import type { IMasterDataRetailerMatchRuleRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataRetailerMatchRuleDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataRetailerMatchRuleUseCase {
  private readonly repository: IMasterDataRetailerMatchRuleRepository;

  constructor(repository: IMasterDataRetailerMatchRuleRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataRetailerMatchRuleDTO) {
    return this.repository.createMatchRule(params);
  }
}
